import { useAuth } from "@/components/auth/auth-context";
import { ChurnAnalysisModal } from "@/components/mentorships/churn-analysis-modal";
import { UserRole } from "@/lib/api/user";
import { BarChart3 } from "lucide-react";
import { useState } from "react";

interface ChurnAnalysisButtonProps {
  mentorshipId: string;
  isDeactivated: boolean;
}

export function ChurnAnalysisButton({
  mentorshipId,
  isDeactivated,
}: ChurnAnalysisButtonProps) {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  // Only show for admin/superadmin users
  const isAdmin =
    user?.role === UserRole.ADMIN || user?.role === UserRole.SUPERADMIN;

  // Only show for deactivated mentorships
  if (!isAdmin || !isDeactivated) {
    return null;
  }

  return (
    <>
      <div
        className="flex cursor-pointer items-center px-4 py-2 transition-colors hover:bg-zinc-100"
        onClick={() => setOpen(true)}
      >
        <BarChart3 className="mr-3 h-5 w-5 text-zinc-500" />
        <span className="text-base text-zinc-700">Churn analysis</span>
      </div>
      <ChurnAnalysisModal
        mentorshipId={mentorshipId}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
